module.exports = __webpack_public_path__ + "img/minor.760cc473.jpg";